import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { searchTextState, searchStoreTicketTextState,searchSTAgentTableTextState } from '../../redux/stores'

class SearchField extends Component {

   constructor() {
        super()
        this.state = {
          searchTextPlaceholder:"Enter Store details..."
        }
      }

  handleOnKeyUp = () => {
    this.props.search(this.refs.searchInput.value)
    if(window.location.pathname==="/dashboard/stores/list"){
          this.props.dispatch(searchTextState(this.refs.searchInput.value))
    }else if(window.location.pathname==="/dashboard/storestickets/agents/list"){
          this.props.dispatch(searchSTAgentTableTextState(this.refs.searchInput.value))
          
    }else{
          this.props.dispatch(searchStoreTicketTextState(this.refs.searchInput.value))      
    }
    this.props.callback()
  
  }

  componentDidMount() {
     if(window.location.pathname==="/dashboard/stores/list"){
        if (this.props.stores && this.props.stores.previousSearchText) {
          this.setValue(this.props.stores.previousSearchText)
        } else {
          this.setValue("")
        }
      }else if(window.location.pathname==="/dashboard/storestickets/agents/list"){
          if (this.props.stores && this.props.stores.previousSTAgentTableSearchText) {
              this.setValue(this.props.stores.previousSTAgentTableSearchText)
          }else {
            this.setValue("")
          }

          this.setState({
            searchTextPlaceholder:"Enter Agent details..." 
          });
      }else{
        if (this.props.stores && this.props.stores.previousStoreTicketSearchText) {
          this.setValue(this.props.stores.previousStoreTicketSearchText)
        } else {
          this.setValue("")
        }
        this.setState({
            searchTextPlaceholder:"Enter Store Ticket details..." 
          });
      }
      
  }

  setValue(value) {
    ReactDOM.findDOMNode(this.refs.searchInput).value = value
    this.props.search(value)
  }

  render() {
    return (
      <input
        ref='searchInput'
        className='form-control'
        type='text'
        defaultValue={this.props.defaultValue}
        placeholder={this.state.searchTextPlaceholder}
        onKeyUp={this.handleOnKeyUp} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    stores: state.stores
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(SearchField)


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/TableCustomComponents/SearchField.js